import _ from "lodash";
/**--external-- */
import React from "react";
import { connect } from "react-redux";

/**--internal-- */
import UILabel from "UIComponents/UILabel";
import ProfileCascade from "UIComponents/ProfileCascade";
import I18nHOC from "UIComponents/I18nHOC";
import { compose } from "lib/apolloClient";
import ChatbarWrapper from "UIComponents/ChatbarWrapper/ChatbarWrapper";

/**--relative-- */
import Field from "../Field";
import classes from "./FieldReflection.scss";
import profileAvatarStyles from "./ReflectionStyles";
import { DEFAULT_MESSAGE_DATA } from "./FieldReflectionUtils";

class FieldReflection extends Field {
  renderPreviewContent = () => {
    const { userInfo, t } = this.props;
    const { id, firstName, profile_image } = userInfo;
    const profileCascadeItems = [
      { id, value: firstName, imageUrl: profile_image },
    ];
    return (
      <div className={classes.responseItemContainer}>
        <ProfileCascade
          items={profileCascadeItems}
          avatarStyles={profileAvatarStyles}
          showAvatar={true}
        />
        <div className={classes.chatbarContainer}>
          <ChatbarWrapper
            messageData={DEFAULT_MESSAGE_DATA}
            sendMessage={_.noop}
            inputTextPlaceHolder={t("common:write_your_reflection_here")}
            cancelEditMessage={_.noop}
            collaborators={[]}
            mode={"VIEW"}
            onDropDownOptionClick={_.noop}
            onFocus={_.noop}
            customDropdownRef={_.noop}
            isStickyContainer={false}
          />
        </div>
      </div>
    );
  };

  getLabel = () => {
    const { label, isRequired } = this.props;
    return `${label}${isRequired && !!label ? `*` : ``}`;
  };

  renderLabel = () => {
    const {
      label,
      subText,
      prompts,
      userType,
      labelStyle,
      subTextStyle,
      labelComponent,
      labelContainerStyle,
      isSinglePageAndNewUnitView = false,
      shouldShowPromptsForStudent = false,
    } = this.props;

    return _.isEqual(userType, "staff") ? (
      <UILabel
        label={this.getLabel()}
        subText={subText}
        labelComponent={labelComponent}
        labelStyle={labelStyle}
        labelContainerStyle={labelContainerStyle}
        subTextStyle={subTextStyle}
        isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
      />
    ) : (
      <UILabel
        label={label}
        subText={prompts}
        labelComponent={
          shouldShowPromptsForStudent ? labelComponent : undefined
        }
        labelStyle={labelStyle}
        labelContainerStyle={labelContainerStyle}
        subTextStyle={subTextStyle}
      />
    );
  };

  shouldShowViewEmpty = () => {
    const { responses } = this.props;

    return _.get(responses, "totalCount", 0) == 0;
  };
}

const mapStateToProps = (state, ownProps) => {
  const { t, isSinglePageAndNewUnitView } = ownProps;
  const userInfo = _.get(state, "login.userInfo", {});
  const { user_type: userType } = userInfo;

  const isParentOrStudent = _.includes(["parent", "student"], userType);
  const emptyText =
    userType === "staff" || (isSinglePageAndNewUnitView && isParentOrStudent)
      ? ownProps.emptyText
      : t("common:content_not_accessible_by_student_and_family");

  return {
    userInfo,
    userType,
    emptyText,
  };
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps)
)(FieldReflection);

FieldReflection.displayName = "FieldReflection";
